import { styled } from '@mui/material/styles';
import { COLOR } from '@src/styles/color';

export const StyledFeedbackContent = styled('div')`
  display: flex;
  align-items: center;
  gap: 16px;
  flex-direction: column;

  .description {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
  }

  .note {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;
    border: 0.5px solid ${COLOR.orangeV2[32]};
    border-radius: 12px;
    background-color: ${COLOR.orangeV2[8]};

    .img-containter {
      width: 24px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 4px;

      img {
        width: 16px;
        height: 16px;
      }
    }
  }
`;
